<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:20px;width:100%;">
            <div style="width:260px;float: left;" class="whiteBox searchbox">
                <h4>
                    <i class="el-icon-d-arrow-right"></i> 筛选条件
                </h4>
                <div class="filter-container search-box">
                    <el-form label-position="top" label-width="80px">
                        <el-form-item label="搜索">
                            <el-input
                                size="mini"
                                maxlength="30"
                                style="width:220px;top:2px;"
                                placeholder="姓名或手机号或其他联系号码"
                                v-model="searchQuery.key">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="到店时间">
                            <el-date-picker v-model="searchQuery.dateRange1" type="daterange" size="mini"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="datePickerOption" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-select size="mini" style="width:180px;" v-model="sortType" placeholder="请选择">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option label="新建流量" :value="1"></el-option>
                                <el-option label="确认到店" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户级别">
                            <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.level">
                                <el-option v-for="item in levelOptions" :key="item.dataName" :label="item.dataDisplay"
                                    :value="item.dataName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px;">
                        <el-button
                            :loading="listLoading"
                            size="small"
                            icon="el-icon-search"
                            class="filter-item"
                            @click="retrieveTables"
                        >筛选</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="filter-item" @click="reset">重置</el-button>
                    </div>
                </div>
            </div>
            <div style="margin-left: 320px; overflow:auto;margin-right:20px;padding:0px 20px;">
                <h1 class="page_title">前台流量</h1>
                <div class="filter-container">
                    <div style="margin-bottom: 10px;">
                        <el-radio-group size="small" v-model="sortType" @change="retrieveTables">
                            <el-radio-button :label="0">全部</el-radio-button>
                            <el-radio-button :label="1">新建流量</el-radio-button>
                            <el-radio-button :label="2">确认到店</el-radio-button>
                        </el-radio-group>
                    </div>

                    <el-button size="small" icon="el-icon-plus" class="filter-item" @click="showNewDialog">新建流量</el-button>
                    <el-button size="small" icon="el-icon-bell" class="filter-item"
                        @click="showInformComeDialog">确认到店</el-button>
                </div>
                <el-table :data="tableRecords" stripe @selection-change="handleSelectionChange" v-loading="listLoading">
                    <el-table-column type="selection" width="45"></el-table-column>
                    <el-table-column align="left" label="姓名" min-width="160">
                        <template slot-scope="scope">
                            <span class="click_link" @click="toDetailPage(scope.row.customerId)">{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="客户经理" width="120">
                        <template slot-scope="scope">{{ scope.row.ownerName }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="级别" width="120">
                        <template slot-scope="scope">{{ scope.row.level | levelDisplay }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="意向车型" min-width="200">
                        <template slot-scope="scope">{{ scope.row.specName }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="类型" min-width="120">
                        <template slot-scope="scope">{{ scope.row.deskType | deskTypeDisplay }}</template>
                    </el-table-column>

                    <el-table-column align="left" label="创建时间" width="139">
                        <template slot-scope="scope">{{ scope.row.createdDate }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="最近跟进" width="136">
                        <template slot-scope="scope">{{ scope.row.updatedDate }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="下次跟进" width="130px">
                        <template slot-scope="scope">
                            <span v-show="scope.row.nextFollowDate != ''">{{ scope.row.nextFollowDate }}</span>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="pagination-container">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="新建流量" :visible.sync="newDialog" width="900px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <el-form ref="newForm" :inline="true" label-position="right" :model="newCustomer" :rules="newCustomerRules"
                label-width="95px">
                <div class="pure-g">
                    <div class="add-title">客户信息</div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="姓名" prop="name">
                            <el-input maxlength="30" size="mini" style="width: 160px;" v-model="newCustomer.name"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="手机号" prop="mobile">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.mobile"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="微信号">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.weixin"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="性别" prop="gender">
                            <el-radio-group v-model="newCustomer.gender" size="mini">
                                <el-radio-button :label="1">先生</el-radio-button>
                                <el-radio-button :label="2">女士</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="上牌类型">
                            <el-radio-group v-model="newCustomer.type" size="mini">
                                <el-radio-button :label="1">个人</el-radio-button>
                                <el-radio-button :label="2">企业</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="newCustomer.type == 2">
                        <el-form-item class="form_item" label="企业名称" prop="companyName"
                            :rules="newCustomer.type == 2 ? newCustomerRules.companyName : newCustomerRules.notRequired">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.companyName"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="客户来源">
                            <el-select size="mini" style="width:160px;" v-model="newCustomer.fromSource">
                                <el-option v-for="item in newFromSourceOptions" :key="item.dataValue" :label="item.dataDisplay"
                                    :value="item.dataValue"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;"
                        v-show="newCustomer.fromSource == 98 || newCustomer.fromSource == 99">
                        <el-form-item class="form_item" :label="newCustomer.fromSource == 98 ? '网络来源' : '自定义来源'">
                            <el-select size="mini" style="width:160px;" v-model="newCustomer.otherSource" clearable>
                                <el-option v-for="item in customizationList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="其他联系号码">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.secondardPhone"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="更多">
                            <el-switch v-model="value1"></el-switch>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
                        <el-form-item class="form_item" label="所在地">
                            <el-cascader v-model="home" :options="homeOptions" :props="props" size="small"></el-cascader>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
                        <el-form-item class="form_item" label="联系地址">
                            <el-input size="mini" style="width: 200px;" v-model="newCustomer.addition.address"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value1">
                        <el-form-item class="form_item" label="身份证">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.addition.idNo"></el-input>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value1">
                        <el-form-item class="form_item" label="生日">
                            <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.addition.birthday"
                                :clearable="false" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value1">
                        <el-form-item class="form_item" label="QQ">
                            <el-input size="mini" style="width: 160px;" v-model="newCustomer.addition.qq"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="pure-g">
                    <div class="add-title">购车意向</div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="意向车系" prop="specIds">
                            <el-select size="mini" style="width: 290px;" placeholder="选择意向车系" :multiple-limit="5" multiple
                                v-model="newCustomer.specIds" filterable>
                                <el-option v-for="item in seriesOptions" :key="item.specId" :label="item.name"
                                    :value="item.specId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="意向竞品">
                            <el-select size="mini" style="width: 290px;" placeholder="选择意向竞品" multiple :multiple-limit="5"
                                v-model="newCustomer.competitionSerieses" filterable>
                                <el-option v-for="(item, index) in competitionSeriesesOptions" :key="index"
                                    :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="购车类型">
                            <el-select size="mini" style="width:160px;" v-model="newCustomer.businessType">
                                <el-option v-for="item in businessTypeOptions" :key="item.dataValue"
                                    :label="item.dataDisplay" :value="item.dataValue"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="newCustomer.businessType == 4">
                        <el-form-item class="form_item" label="采购数量">
                            <el-input-number size="mini" v-model="newCustomer.buyCount" :min="0"
                                :max="10000"></el-input-number>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="意向级别">
                            <el-select size="mini" style="width:160px;" v-model="newCustomer.level" @change="changeLevel">
                                <el-option v-for="item in followLevelOptions" :key="item.dataName" :label="item.dataDisplay"
                                    :value="item.dataName"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2 buy-car-address" style="padding-bottom:12px;">
                        <el-form-item class="form_item" prop="buyCarAddress">
                        <div slot="label">
                            <span style="color: #f56c6c;margin-right: 4px;">*</span>
                            <span>购车地区</span>
                            <el-popover
                            placement="top-start"
                            title=""
                            width="210"
                            trigger="hover"
                            content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                            <i slot="reference" style="margin-left: 5px;" class="el-icon-question"></i>
                            </el-popover>
                            
                        </div>
                        <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince"
                            v-model="newCustomer.buyProvince">
                            <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                        <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity"
                            v-model="newCustomer.buyCity">
                            <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                        <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="newCustomer.buyArea">
                            <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="购车预算">
                            <el-select size="mini" style="width:160px;" v-model="newCustomer.budget">
                                <el-option v-for="item in budgetOptions" :key="item.dataValue" :label="item.dataDisplay"
                                    :value="item.dataValue"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="预计购车时间" label-width="90px" style="margin-right: 5px;">
                            <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.buycarDate"
                                :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <div style="font-size: 13px;display:inline-block;height: 100%;line-height: 28px;">之前</div>
                    </div>
                </div>
                <div class="pure-g">
                    <div class="add-title">下次跟进计划</div>
                    <div class="pure-u-1-1" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="客户经理" prop="memberId">
                            <el-select size="mini" style="width:160px;" placeholder="选择客户经理" v-model="newCustomer.memberId"
                                filterable>
                                <el-option v-for="item in assignMembers" :key="item.memberId"
                                    :label="item.userName + '(' + item.clueCount + ')'" :value="item.memberId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="跟进方式">
                            <el-radio-group size="small" v-model="newCustomer.nextActivityType">
                                <el-radio-button v-for="item in activityNextFollowTypes" :key="item.dataValue"
                                    :label="item.dataValue">{{ item.dataDisplay }}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-2" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="跟进日期">
                            <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.nextDate"
                                :clearable="false" readonly type="date"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="pure-u-1-1" style="padding-bottom:12px;">
                        <el-form-item class="form_item" label="备注">
                            <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                                v-model="newCustomer.remark"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="doAdd" type="text">保存</el-button>
                <el-button @click="handleCancelAdd" type="text">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="再分配" :visible.sync="assignDialog" width="350px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <el-form ref="assignForm" label-position="right" :model="assignForm" :rules="assignFormRules"
                label-width="80px">
                <el-form-item class="form_item_val" label="客户经理" prop="memberId">
                    <el-select size="mini" v-model="assignForm.memberId">
                        <el-option v-for="item in members" :key="item.memberId" :label="item.userName"
                            :value="item.memberId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form_item_val" label="备注">
                    <el-input type="textarea" :rows="2" placeholder="请输入备注内容" v-model="assignForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="doAssign" type="text">确定</el-button>
                <el-button @click="assignDialog = false" type="text">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="客户导入" :visible.sync="importDialog" width="400px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <div style="text-align:center;">
                <el-upload class="upload-demo" accept=".xlsx" drag action :file-list="uploadFiles"
                    :http-request="uploadRequest" :limit="1" :on-success="uploadSuccess" :on-remove="uploadRemove"
                    :before-upload="uploadBefore">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或
                        <em>点击上传</em>
                    </div>
                    <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
                </el-upload>
                <div>
                    <a href="http://cxs1.oss-cn-shenzhen.aliyuncs.com/zhizhu/template/%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
                        class="click_link">下载模版</a>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button :loading="uploadLoading" @click="doImport" type="text">{{ uploadLoading ? '导入中...' :
                    '确定' }}</el-button>
                <el-button @click="hideImportDialog" v-show="!uploadLoading" type="text">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="确认到店" :visible.sync="informComeDialog" width="700px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <div class="pure-g">
                <div class="pure-u-1-3">
                    <el-input
                        size="mini"
                        maxlength="30"
                        style="width: 160px;"
                        v-model="informComeQuery.key"
                        placeholder="输入姓名或手机号">
                    </el-input>
                    <div style="margin-top:10px;">
                        <el-button size="mini" class="filter-item" :loading="isSearching" @click="searchCustomer">搜索客户</el-button>
                    </div>
                </div>
                <div class="pure-u-2-3" style="height:340px;">
                    <div>
                        <el-table :data="informRecords"  v-loading="isSearching" stripe>
                            <el-table-column align="left" label="姓名" min-width="160">
                                <template slot-scope="scope">
                                    <span class="click_link" @click="toDetailPage(scope.row.id)">{{ scope.row.name + ' - ' +
                                        scope.row.mobile }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="left" label="客户经理" width="80">
                                <template slot-scope="scope">{{ scope.row.deal.ownerName }}</template>
                            </el-table-column>
                            <el-table-column align="left" label="级别" width="80">
                                <template slot-scope="scope">{{ scope.row.deal.level + '级' }}</template>
                            </el-table-column>
                            <el-table-column align="center" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="doInformCome(scope.row)">确认到店</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-container" style="margin-top:10px;"
                            v-show="informComeTotal > informComeQuery.limit">
                            <el-pagination background @size-change="handleInformSizeChange"
                                @current-change="handleInformCurrentChange" :current-page="informComeQuery.page"
                                :page-sizes="[10, 20, 30, 50]" :page-size="informComeQuery.limit" small
                                layout="prev, pager, next" :total="informComeTotal"></el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="informComeDialog = false" type="text">关闭</el-button>
            </span>
        </el-dialog>

        <!-- blc拦截弹窗 -->
        <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
    </div>
</template>

<script>
import oss from '../../assets/js/ali-oss';
import BlcTips from "@/components/blc-tips/index.vue";
var customer_list_vm;
export default {
    components: { BlcTips },
    data() {
        customer_list_vm = this;
        const validateBuyCarAddress = (rule, value, callback) => {
            const [buyProvince, buyCity] = value
            if (!!buyProvince&&!!buyCity) {
                callback();
            } else {
                callback(new Error("请选择购车地区"));
            }
        }
        return {
            isSearching: false,
            showBlcTips: false,
            blcInfo: {},
            listLoading: false,
            dealer: this.$common.getDealer(),
            user: this.$common.getUser(),
            isAdmin: this.$common.isAdmin(),

            searchQuery: {
                key: "",
                dateRange1: [
                    new Date().Format("yyyy-MM-dd"),
                    new Date().Format("yyyy-MM-dd")
                ],
                level: []
            },
            sortType: 0,

            tableRecords: [],
            multipleSelection: [],

            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },

            datePickerOption: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: "今日",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "昨日",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 1
                            );
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 6
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 29
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 89
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 364
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },

            customerOrderOptions: [],
            fromSourceOptions: [],
            importSourceOptions: [],
            businessTypeOptions: [],
            levelOptions: [],
            followLevelOptions: [],
            members: [],

            newDialog: false,
            newCustomer: {
                name: "",
                mobile: "",
                weixin: "",
                gender: "",
                type: 1,
                companyName: "",
                fromSource: 1,
                otherSource: "",
                secondardPhone: "",
                specIds: [],
                memberId: "",
                competitionSerieses: [],
                budget: 1,
                businessType: 1,
                level: "N",
                nextActivityType: 1,
                nextDate: new Date(),
                buycarDate: "",
                nextTestSpecId: "",
                remark: "",
                buyCount: "",
                buyCarAddress: [],//购车地区-省市区
                buyProvince: '',// 购车地区-省
                buyCity: '',// 购车地区-市
                buyArea: '',// 购车地区-区
                addition: {
                    province: "",
                    city: "",
                    address: "",
                    idNo: "",
                    birthday: "",
                    qq: ""
                }
            },
            newCustomerRules: {
                name: [
                    {
                        required: true,
                        message: "请输入客户姓名",
                        trigger: "blur"
                    }
                ],
                specIds: [
                    {
                        required: true,
                        message: "请选择意向车系",
                        trigger: "change"
                    }
                ],
                gender: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                mobile: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    }
                ],
                companyName: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "blur"
                    }
                ],
                memberId: [
                    {
                        required: true,
                        message: "请选择客户经理",
                        trigger: "change"
                    }
                ],
                specId: [
                    {
                        required: true,
                        message: "请选择意向车型",
                        trigger: "change"
                    }
                ],
                nextTestSpecId: [
                    {
                        required: true,
                        message: "请选择意向车型",
                        trigger: "change"
                    }
                ],
                notRequired: [
                    {
                        required: false,
                        message: "请选择意向车型",
                        trigger: "change"
                    }
                ],
                buyCarAddress: [
                    {
                        // type: 'array',
                        required: true,
                        message: "请选择购车地区",
                        trigger: "change",
                        validator: validateBuyCarAddress,
                    },
                ]
            },
            carOptions: [],
            seriesOptions: [],

            assignDialog: false,
            assignForm: {
                memberId: "",
                remark: ""
            },
            assignFormRules: {
                memberId: [
                    {
                        required: true,
                        message: "请选择客户经理",
                        trigger: "blur"
                    }
                ]
            },

            importDialog: false,
            uploadFiles: [],
            uploadFile: "",
            uploadLoading: false,
            assignMembers: [],

            informComeDialog: false,
            informComeTotal: 0,
            informComeQuery: {
                page: 1,
                limit: 5,
                key: ""
            },
            informRecords: [],
            orderType: 0,
            value1: false,
            activityNextFollowTypes: [],
            budgetOptions: [],
            home: [],
            homeOptions: [],
            props: {
                value: "city",
                label: "city",
                children: "cities"
            },
            competitionSeriesesOptions: [],
            customizationList: [],
            provinces: [],// 省份
            buyCarCityList: [],// 购车地区-城市列表
            buyCarAreaList: [],// 购车地区-城市列表
            dealerProvince: '',// 门店所在省份
            dealerCity: '',// 门店所在市
            dealerArea: '',// 门店所在区
            baseInfo: {},
        };
    },
    filters: {
        levelDisplay(level) {
            for (var i = 0; i < customer_list_vm.levelOptions.length; i++) {
                var o = customer_list_vm.levelOptions[i];
                if (o.dataName == level) {
                    return o.dataDisplay;
                }
            }
            return "";
        },
        deskTypeDisplay(type) {
            const map = {
                "1": "新建流量",
                "2": "确认到店"
            };
            return map[type];
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path.startWith("/customer/detail/")) {
                try {
                    var listFilters = JSON.parse(
                        sessionStorage.getItem("listFilters")
                    );
                    vm.searchQuery = listFilters.searchQuery;
                    vm.sortType = listFilters.sortType;
                    vm.total = listFilters.total;
                    vm.listQuery = listFilters.listQuery;
                } catch (error) { 
                    console.log(error)
                }
            }
            vm.getList();
        });
    },
    created() {
        this.baseInfo = this.$common.getBaseInfo();
        this.customerOrderOptions = this.baseInfo.customerListOrders;
        this.fromSourceOptions = this.baseInfo.customerFromSources;
        this.importSourceOptions = this.baseInfo.importSources;
        this.businessTypeOptions = this.baseInfo.businessTypes;
        this.followLevelOptions = this.baseInfo.customerFollowLevels;
        this.levelOptions = this.baseInfo.customerLevels;
        this.activityNextFollowTypes = this.baseInfo.activityNextFollowTypes;
        this.budgetOptions = this.baseInfo.budgets;
        this.budgetOptions.forEach(item => {
            item.dataDisplay = item.dataDisplay + "万元";
        });
        this.homeOptions = this.baseInfo.cities;
        this.homeOptions.forEach(item => {
            item.city = item.province;
        });
        this.retrieveMembers();
        this.retrieveCarOptions();
        this.retrieveSeriesOptions();
        this.getCompetitionSeriesesOptions();
        this.retrieveAssignMembers();
        this.getcustomizationList();
        this.getProvinces();
    },
    mounted() {
        // this.retrieveTables();
    },
    computed: {
    newFromSourceOptions() {
       if (!this.baseInfo || !Array.isArray(this.baseInfo.customerFromSources)) {
            return [];
        }
        // 去掉跨品牌转介绍和新媒体的客户来源
        return this.baseInfo.customerFromSources.filter((item) => item.dataDisplay != '跨品牌转介绍' && item.dataDisplay != '新媒体')
    }
  },
    methods: {
        // 获取省
        getProvinces() {
            this.$httpAuth
            .post("/v2/appCustomerService/orderRegion", {
                dealerId: this.dealer.dealerId,
                province: "",
                city: "",
            })
            .then((res) => {
                this.provinces = res.data.data;
                this.dealerProvince = res.data.province;
                this.dealerCity = res.data.city;
                this.dealerArea = res.data.county;
            });
        },
        // 获取市
        getCityList(provinceName) {
            return new Promise((resolve,reject)=> {
                this.$httpAuth
                .post("/v2/appCustomerService/orderRegion", {
                    dealerId: this.dealer.dealerId,
                    province: provinceName,
                    city: "",
                })
                .then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取区
        getAreaList(params) {
            return new Promise((resolve,reject) => {
                this.$httpAuth
                .post("/v2/appCustomerService/orderRegion", params)
                .then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 改变购车地区省
        changeBuyCarProvince(provinceName) {
            this.newCustomer.buyCity = "";
            this.newCustomer.buyArea = "";
            this.buyCarCityList = [] // 清除市列表
            this.buyCarAreaList = [] // 清除区列表
            if (provinceName) {
                this.getCityList(provinceName).then(res => {
                this.buyCarCityList = res.data.data;
                })
                this.newCustomer.buyCarAddress = [provinceName]// 重置选择项
                
            } else {
                this.newCustomer.buyProvince = "";
                this.newCustomer.buyCarAddress = []// 重置选择项
            }
        },
        // 改变购车城市
        changeBuyCarCity(cityName) {
            const params = {
                dealerId: this.dealer.dealerId,
                province: this.newCustomer.buyProvince,
                city:cityName
            }
            this.newCustomer.buyArea = "";// 清除区
            this.buyCarAreaList = []// 清除区列表
            // 选择区域
            if (cityName) {
                // 获取区域
                this.getAreaList(params).then(res => {
                this.buyCarAreaList = res.data.data;
                })
                this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0], cityName]// 重置选择项
            } else {
                // 清空市
                this.newCustomer.buyCity = "";// 清除市
                this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0]]// 重置选择项
            }
        },
        // 改变购车地区区域
        changeBuyCarArea(areaName) {
            if (areaName) {
                this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1], areaName]// 重置选择项
            } else {
                this.newCustomer.buyArea = "";
                this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1]]// 重置选择项
            }
            this.$forceUpdate()
        },
        // 其他来源数据
        getcustomizationList() {
            this.$httpAuth
                .post("/v2/appDealerManagerService/sourceList", {
                    dealerId: this.dealer.dealerId
                })
                .then(res => {
                    this.customizationList = res.data.data;
                });
        },
        retrieveAssignMembers() {
            var parent = this;
            this.$httpAuth
                .post("v2/appDealerManagerService/assignMembers", {
                    dealerId: this.dealer.dealerId,
                    isAll: true
                })
                .then(function (response) {
                    parent.assignMembers = response.data.data;
                });
        },
        retrieveMembers() {
            var parent = this;
            this.$httpAuth
                .post("/v1/dealerMemberRpc/managerMembers", {
                    dealerId: this.dealer.dealerId
                })
                .then(function (response) {
                    parent.members = response.data.data;
                });
        },
        retrieveSeriesOptions() {
            var parent = this;
            this.$httpAuth
                .post("/v1/dealerRpc/seriesList", {
                    dealerId: this.dealer.dealerId
                })
                .then(function (response) {
                    parent.seriesOptions = response.data.records;
                });
        },
        retrieveCarOptions() {
            var parent = this;
            this.$httpAuth
                .post("/v1/dealerRpc/vehicleJsonTree", {
                    dealerId: this.dealer.dealerId
                })
                .then(function (response) {
                    parent.carOptions = response.data.data;
                });
        },
        retrieveTables() {
            this.listQuery.page = 1;
            this.getList();
        },
        reset() {
            this.searchQuery = {
                key: "",
                dateRange1: [
                    new Date().Format("yyyy-MM-dd"),
                    new Date().Format("yyyy-MM-dd")
                ],
                level: []
            };
            this.retrieveTables();
        },
        getCompetitionSeriesesOptions() {
            var that = this;
            this.$httpAuth
                .post("/v1/dealerRpc/getCompetitionSeriesList", {
                    dealerId: that.dealer.dealerId,
                    key: ""
                })
                .then(function (response) {
                    that.competitionSeriesesOptions = response.data.data;
                });
        },
        // 表格上的排序
        sortChange(data) {
            if (data.order == "ascending") {
                this.orderType = 1;
            } else if (data.order == "descending") {
                this.orderType = 0;
            } else {
                this.orderType = 0;
            }
            this.getList();
        },
        getList() {
            if (this.listLoading) return
            var parent = this;
            this.retrieveAssignMembers();
            this.listLoading = true;
            const start = this.searchQuery.dateRange1 ? this.searchQuery.dateRange1[0]: null;
            const end = this.searchQuery.dateRange1 ? this.searchQuery.dateRange1[1]: null;
            this.$httpAuth
                .post("/v2/appCustomerDeskService/list", {
                    dealerId: this.dealer.dealerId,
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    levels: this.searchQuery.level.join(","),
                    key: this.searchQuery.key,
                    type: this.sortType,
                    createdDate: {
                        start,
                        end
                    },
                    orderType: 0
                })
                .then(function (response) {
                    parent.listLoading = false;
                    parent.tableRecords = response.data.data;
                    parent.total = response.data.total;
                })
                .catch(() => { });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        changeLevel() {
            let days = 0;
            for (let i = 0; i < this.followLevelOptions.length; i++) {
                let o = this.followLevelOptions[i];
                if (o.dataName == this.newCustomer.level) {
                    days = o.dataValue;
                    break;
                }
            }
            console.log(days)
            // this.newCustomer.nextDate = this.$common.addDate(new Date(), days);
        },
        showNewDialog() {
            this.newCustomer = {
                name: "",
                mobile: "",
                weixin: "",
                gender: "",
                type: 1,
                companyName: "",
                fromSource: 1,
                otherSource: "",
                secondardPhone: "",
                specIds: [],
                memberId: "",
                competitionSerieses: [],
                budget: 1,
                businessType: 1,
                level: "N",
                nextActivityType: 1,
                nextDate: new Date(),
                buycarDate: "",
                nextTestSpecId: "",
                remark: "",
                buyCount: 0,
                buyCarAddress: [this.dealerProvince, this.dealerCity, this.dealerArea],//购车地区
                buyProvince: this.dealerProvince,// 门店所在省份
                buyCity: this.dealerCity,// 门店所在市
                buyArea: this.dealerArea,// 门店所在区
                addition: {
                    province: "",
                    city: "",
                    address: "",
                    idNo: "",
                    birthday: "",
                    qq: ""
                }
            };
            this.changeLevel();
            this.newDialog = true;
            this.buyCarCityList = [] // 清除市列表
            this.buyCarAreaList = [] // 清除区列表
            this.$nextTick(() => {
                this.$refs["newForm"].clearValidate();
            })
            if (this.dealerProvince) {
                this.getCityList(this.dealerProvince).then(res => {
                this.buyCarCityList = res.data.data;
                })
            }
            if (this.dealerCity) {
                this.getAreaList({
                dealerId: this.dealer.dealerId,
                province: this.dealerProvince,
                city: this.dealerCity
                }).then(res => {
                this.buyCarAreaList = res.data.data;
                })
            }
        },

        doAdd() {
            this.$refs["newForm"].validate(valid => {
                if (valid) {
                    if (
                        this.newCustomer.fromSource == 99 &&
                        !this.newCustomer.otherSource
                    ) {
                        this.$message({
                            message: "请选择自定义来源",
                            type: "warning"
                        });
                        return;
                    }
                    var parent = this;
                    if (parent.home.length !== 0) {
                        parent.newCustomer.addition.province = parent.home[0];
                        parent.newCustomer.addition.city = parent.home[1];
                    }
                    // 购车地区
                    const [buyProvince, buyCity, buyArea=''] = this.newCustomer.buyCarAddress
                    this.$httpAuth
                        .post("/v2/appCustomerService/add", {
                            dealerId: this.dealer.dealerId,
                            name: this.newCustomer.name,
                            mobile: this.newCustomer.mobile,
                            weixin: this.newCustomer.weixin,
                            gender: this.newCustomer.gender,
                            type: this.newCustomer.type,
                            companyName: this.newCustomer.companyName,
                            fromSource: this.newCustomer.fromSource,
                            otherSource: this.newCustomer.otherSource + "",
                            addition: {
                                province: this.newCustomer.addition.province,
                                city: this.newCustomer.addition.city,
                                address: this.newCustomer.addition.address,
                                idNo: this.newCustomer.addition.idNo,
                                birthday: this.newCustomer.addition.birthday,
                                qq: this.newCustomer.addition.qq
                            },
                            secondardPhone: this.newCustomer.secondardPhone,
                            tags: "",
                            level: this.newCustomer.level,
                            specIds: this.newCustomer.specIds.join(","),
                            competitionSerieses: this.newCustomer.competitionSerieses.join(
                                ","
                            ),
                            budget: this.newCustomer.budget,
                            nextActivityType: this.newCustomer.nextActivityType,
                            nextDate: parseInt(
                                this.newCustomer.nextDate.getTime() / 1000
                            ),
                            buycarDate:
                                this.newCustomer.buycarDate !== ""
                                    ? parseInt(
                                        this.newCustomer.buycarDate.getTime() /
                                        1000
                                    )
                                    : 0,
                            nextTestSpecId: +this.newCustomer.nextTestSpecId,
                            isRepace: true,
                            businessType: this.newCustomer.businessType,
                            customSource: this.newCustomer.customSource,
                            buyCount: this.newCustomer.buyCount,
                            buyProvince,
                            buyCity,
                            buyArea,
                            remark: this.newCustomer.remark,
                            assignMemberId: this.newCustomer.memberId,
                            newType: 1
                        })
                        .then(response=> {
                            if (response.data.code == 202 && response.data.status== -2) {
                                this.blcInfo = {
                                name: this.newCustomer.name,
                                mobile: this.newCustomer.mobile,
                                idNo: this.newCustomer.addition.idNo,
                                detail: response.data.detail
                                }
                                this.showBlcTips = true;
                                return;
                            }
                            parent.newDialog = false;
                            parent.retrieveTables();
                        })
                        .catch(() => { });
                }
            });
        },
        handleCancelAdd() {
            this.newDialog = false
            this.$refs["newForm"].resetFields()
        },
        showAssignDialog() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: "请选择再分配客户",
                    type: "warning"
                });
                return;
            }
            this.assignForm = {
                memberId: "",
                remark: ""
            };
            if (this.$refs["assignForm"]) {
                this.$refs["assignForm"].resetFields();
            }
            this.assignDialog = true;
        },
        doAssign() {
            var ids = [];
            for (var i = 0; i < this.multipleSelection.length; i++) {
                var o = this.multipleSelection[i];
                ids.push(o.customerId);
            }
            this.$refs["assignForm"].validate(valid => {
                if (valid) {
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/customerRpc/batchReassign", {
                            dealerId: this.dealer.dealerId,
                            customerIds: ids.join(","),
                            memberId: this.assignForm.memberId,
                            remark: this.assignForm.remark
                        })
                        .then(function (response) {
                            parent.$message(
                                response.data.successTotal +
                                " 位客户再分配成功!"
                            );
                            parent.assignDialog = false;
                            parent.retrieveTables();
                            parent.multipleSelection = [];
                        })
                        .catch(() => { });
                }
            });
        },
        toDetailPage(id) {
            var listFilters = {
                searchQuery: this.searchQuery,
                sortType: this.sortType,
                total: this.total,
                listQuery: this.listQuery
            };
            console.log(this.searchQuery);
            sessionStorage.setItem("listFilters", JSON.stringify(listFilters));
            this.$router.push({
                path: "/customer/detail/" + id + "?a=1"
            });
        },
        showImportDialog() {
            this.importDialog = true;
            this.uploadLoading = false;
        },
        hideImportDialog() {
            this.uploadFiles = [];
            this.uploadFile = "";
            this.importDialog = false;
        },
        uploadBefore(file) {
            if (file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                this.$message.error('请上传xlsx格式文件!')
                return false;
            }
        },
        uploadRequest(option) {
            oss.ossUploadFile(option)
        },
        uploadSuccess(res) {
            this.uploadFile = res;
        },

        uploadRemove() {
            this.uploadFile = "";
        },
        doImport() {
            if (this.uploadFile == "") {
                this.$message({
                    message: "请选择导入文件",
                    type: "warning"
                });
                return;
            }
            var parent = this;
            parent.uploadLoading = true;
            this.$httpAuth
                .post("/v1/customerRpc/import", {
                    dealerId: this.dealer.dealerId,
                    file: this.uploadFile
                })
                .then(function (response) {
                    parent.uploadLoading = false;
                    console.log(response.data);
                    parent.$notify({
                        title: "客户导入结果",
                        dangerouslyUseHTMLString: true,
                        message:
                            "<strong>创建成功 <i>" +
                            response.data.successTotal +
                            "</i> 条客户数据</strong>" +
                            "<br>" +
                            "<strong>重复未能插入 <i>" +
                            response.data.duplicateTotal +
                            "</i> 条客户数据</strong>" +
                            "<br>" +
                            "<strong>失败 <i>" +
                            response.data.failTotal +
                            "</i> 条客户数据</strong>"
                    });
                    parent.hideImportDialog();
                    parent.reset();
                })
                .catch(function () {
                    parent.uploadLoading = false;
                    return;
                });
        },
        showInformComeDialog() {
            this.informComeDialog = true;
            this.informRecords = [];
            this.informComeTotal = 0;
            this.informComeQuery = {
                page: 1,
                limit: 5,
                key: ""
            };
        },
        searchCustomer() {
            this.informComeQuery.page = 1;
            this.getInformCustomerList();
        },
        getInformCustomerList() {
            if (this.isSearching) return;
            this.isSearching = true
            this.informRecords = [];
            this.$httpAuth
                .post("/v1/customerRpc/search", {
                    dealerId: this.dealer.dealerId,
                    pageStart:
                        (this.informComeQuery.page - 1) *
                        this.informComeQuery.limit,
                    pageCount: this.informComeQuery.limit,
                    key: this.informComeQuery.key
                })
                .then(res => {
                    const { data=[], total=0 } = res?.data ?? {}
                    this.informRecords = data;
                    this.informComeTotal = total;
                    if (this.informComeTotal == 0) {
                        this.$message("该客户不存在");
                    }
                }).finally(() => {
                    this.isSearching = false
                })
        },
        handleInformSizeChange(val) {
            this.informComeQuery.limit = val;
            this.getInformCustomerList();
        },
        handleInformCurrentChange(val) {
            this.informComeQuery.page = val;
            this.getInformCustomerList();
        },
        doInformCome(row) {
            this.$confirm("此操作将确认该客户到店, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    var parent = this;
                    this.$httpAuth
                        .post("/v2/appCustomerDeskService/informCome", {
                            dealerId: this.dealer.dealerId,
                            customerId: row.id
                        })
                        .then(function () {
                            parent.$message("确认到店完成");
                        })
                        .catch(() => { });
                })
                .catch(() => { });
        }
    }
};
</script>

<style scoped>
.add-title {
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    color: rgba(10, 18, 32, 0.64);
    letter-spacing: normal;
    margin-bottom: 15px;
    margin-top: 10px;
}
.buy-car-address /deep/.el-form-item__label::before{
  display: none;
}
</style>
